import { EPostbackStatuses } from 'entities/Postback';
import { i18n } from 'i18n';

export const POSTBACK_STATUSES = () => ({
	[EPostbackStatuses.APPROVED]: i18n.t('Открытый'),
	[EPostbackStatuses.PENDING]: i18n.t('Подтвержденный'),
	[EPostbackStatuses.REJECTED]: i18n.t('Отклоненный'),
});
